import BaseCard from './BaseCard';
import { CardType } from './CardType';
import GameObject from '../../../GameObject/GameObject';
import Tornado from './Tornado';

export default class TornadoCard extends BaseCard {
    protected onCreate(params: any): void {
        params.cardFrontTexture = 'card_tornado';
        params.type = CardType.tornado;

        super.onCreate(params);

        const cardFrontSprite = this.getChildByName('cardFrontSprite');

        cardFrontSprite.addChild(GameObject.Instantiate(Tornado));
    }
}
